import styled from 'styled-components';

export const Container = styled.div`
  /* position: relative; */
  background-color: ${(props) => props.theme.white};
  height: 100vh;
  padding: 75px 20px 0 250px;
  overflow: auto;

  @media only screen and (max-width: 1024px) {
    padding: 70px 10px;
    display: block;
    width: 100%;
  }
`;

export const AboutLink = styled.div`
  position: absolute;
  top: 24px;
  right: 40px;
  z-index: 10;
  @media only screen and (max-width: 1024px) {
    right: 16px;
    top: 16px;
  }
`;
